import React from 'react';
import Hermosasquare from './Hermosasquare.js';
import Hummingbird from './Hummingbird.js';
import HummingbirdIris from './HummingbirdIris.js';
import Denton from './Denton.js';
import Maywood from './Maywood.js';
import MaywoodRound from './MaywoodRound.js';
import Fleur from './Fleur.js';
import Mountainviewsquare from './Mountainviewsquare.js';
import Mountainviewrounded from './Mountainviewrounded.js';
import Mountainviewoctagon from './Mountainviewoctagon.js';
import Bakersfield from './Bakersfield.js'
import Cross from './Cross.js'
import Tudor from './Tudor.js';
import Put01 from './Put01.js'
import Put02 from './Put02.js'
import Put03 from './Put03.js'
import Put04 from './Put04.js'
import Put05 from './Put05.js'
import Bakers from './Bakers.js';
import Design5 from './Design5.js'
import Design6 from './Design6.js';   
import Design7 from './Design7.js';
import Sun from './Sun.js';
import Karen from './Karen.js';
import Temecula from './Temecula.js';
import Habra from './Habra.js';
import ArcataArched from './ArcataArched.js';
import ArcateCircular from './ArcataCircular.js';
import ArcataHorizontalRectangle from './ArcataHorizontalRectangle.js';
import ArcataOctagon from './ArcataOctagon.js';
import ArcataSidelite from './ArcataSidelite.js';
import ArcataTransom from './ArcataTransom.js';
import ArcataVerticalRectangle from './ArcataVerticalRectangle.js';
import BarstowArched from './BarstowArched.js';
import BarstowCircular from './BarstowCircular.js';
import BarstowOctagon from './BarstowOctagon.js';
import BarstowTransom from './BarstowTransom.js';
import BarstowVerticalRectangle from './BarstowVerticalRectangle.js';
import BellfloerArched from './BellflowerArched.js';
import BellflowerCircular from './BellflowerCircular.js';
import BellflowerHorizontalRectangle from './BellflowerHorizontalRectangle.js';
import BellflowerOctagon from './BellflowerOctagon.js';
import BellflowerSidelite from './BellflowerSidelite.js';
import BellflowerTransom from './BellflowerTransom.js';
import BellflowerVerticalRectangle from './BellflowerVerticalRectangle.js';
import DentonArched from './DentonArched.js';
import DentonCircular from './DentonCircular.js';
import DentonHorizontalRectangle from './DentonHorizontalRectangle.js';
import DentonOctagon from './DentonOctagon.js';
import DentonSidelite from './DentonSidelite.js';
import DentonTransom from './DentonTransom.js';
import DentonVerticalRectangle from './DentonVerticalRectangle.js';
import HermosaArched from './HermosaArched.js';
import HermosaCircular from './HermosaCircular.js';
import HermosaHorizontalRectangle from './HermosaHorizontalRectangle.js';
import HermosaOctagon from './HermosaOctagon.js';
import HermosaTransom from './HermosaTransom.js';
import HermosaVerticalRectangle from './HermosaVerticalRectangle.js';
import LimerickArched from './LimerickArched.js';
import LimerickCircular from './LimerickCircular.js';
import LimerickHorizontalRectangle from './LimerickHorizontalRectangle.js';
import LimerickOctagon from './LimerickOctagon.js';
import LimerickTransom from './LimerickTransom.js';
import LimerickVerticalRectangle from './LimerickVerticalRectangle.js';
import SunArched from './SunArched.js';
import SunCircular from './SunCircular.js';
import SunHorizontalRectangle from './SunHorizontalRectangle.js';
import SunOctagon from './SunOctagon.js';
import SunTransom from './SunTransom.js';
import SunVerticalRectangle from './SunVerticalRectangle.js';
import FleurArched from './FleurArched.js';
import FleurCircular from './FleurCircular.js';
import FleurHorizontalRectangle from './FleurHorizontalRectangle.js';
import FleurOctagon from './FleurOctagon.js';
import FleurSidelite from './FleurSidelite.js';
import FleurTransom from './FleurTransom.js';
import FleurVerticalRectangle from './FleurVerticalRectangle.js';
import Shelby1S from './Shelby-1S.js';
import Shelby2S from './Shelby-2s.js';
import Shelby3S from './Shelby-3s.js';
import Shelby4S from './Shelby-4s.js';  
import Gentry1S from './Gentry-1S.js';
import Gentry2S from './Gentry-2S.js';
import Gentry3S from './Gentry-3S.js';




const components = {
    "Hermosasquare": Hermosasquare,
    "Hummingbird" : Hummingbird,
    "HummingbirdIris" : HummingbirdIris,
    "Denton" : Denton,
    "Maywood" : Maywood,
    "MaywoodRound" : MaywoodRound,
    "Fleur" : Fleur,
    "Mountainviewsquare" : Mountainviewsquare,
    "Mountainviewrounded" : Mountainviewrounded,
    "Mountainviewoctagon" : Mountainviewoctagon,
    "Bakersfield" : Bakersfield,
    "Cross" : Cross,
    "Tudor" : Tudor,
    "Put01" : Put01,
    "Put02" : Put02,
    "Put03" : Put03,
    "Put04" : Put04,
    "Put05" : Put05,
    "Bakers" : Bakers,
    "Design5" : Design5,
    "Design6" : Design6,
    "Design7" : Design7,
    "Sun" : Sun,
    "Karen" : Karen,
    "Temecula" : Temecula,
    "Habra" : Habra,
    "ArcataArched" : ArcataArched,
    "ArcateCircular" : ArcateCircular,
    "ArcataHorizontalRectangle" : ArcataHorizontalRectangle,
    "ArcataOctagon" : ArcataOctagon,
    "ArcataSidelite" : ArcataSidelite,
    "ArcataTransom" : ArcataTransom,
    "ArcataVerticalRectangle" : ArcataVerticalRectangle,
    "BarstowArched" : BarstowArched,
    "BarstowCircular" : BarstowCircular,
    "BarstowOctagon" : BarstowOctagon,
    "BarstowTransom" : BarstowTransom,
    "BarstowVerticalRectangle" : BarstowVerticalRectangle,
    "BellfloerArched" : BellfloerArched,
    "BellflowerCircular" : BellflowerCircular,
    "BellflowerHorizontalRectangle" : BellflowerHorizontalRectangle,
    "BellflowerOctagon" : BellflowerOctagon,
    "BellflowerSidelite" : BellflowerSidelite,
    "BellflowerTransom" : BellflowerTransom,
    "BellflowerVerticalRectangle" : BellflowerVerticalRectangle,
    "DentonArched" : DentonArched,
    "DentonCircular" : DentonCircular,
    "DentonHorizontalRectangle" : DentonHorizontalRectangle,
    "DentonOctagon" : DentonOctagon,
    "DentonSidelite" : DentonSidelite,
    "DentonTransom" : DentonTransom,
    "DentonVerticalRectangle" : DentonVerticalRectangle,
    "HermosaArched" : HermosaArched,
    "HermosaCircular" : HermosaCircular,
    "HermosaHorizontalRectangle" : HermosaHorizontalRectangle,
    "HermosaOctagon" : HermosaOctagon,
    "HermosaTransom" : HermosaTransom,
    "HermosaVerticalRectangle" : HermosaVerticalRectangle,
    "LimerickArched" : LimerickArched,
    "LimerickCircular" : LimerickCircular,
    "LimerickHorizontalRectangle" : LimerickHorizontalRectangle,
    "LimerickOctagon" : LimerickOctagon,
    "LimerickTransom" : LimerickTransom,
    "LimerickVerticalRectangle" : LimerickVerticalRectangle,
    "SunArched" : SunArched,
    "SunCircular" : SunCircular,
    "SunHorizontalRectangle" : SunHorizontalRectangle,
    "SunOctagon" : SunOctagon,
    "SunTransom" : SunTransom,
    "SunVerticalRectangle" : SunVerticalRectangle,
    "FleurArched" : FleurArched,
    "FleurCircular" : FleurCircular,
    "FleurHorizontalRectangle" : FleurHorizontalRectangle,
    "FleurOctagon" : FleurOctagon,
    "FleurSidelite" : FleurSidelite,
    "FleurTransom" : FleurTransom,
    "FleurVerticalRectangle" : FleurVerticalRectangle,
    "Shelby1S" : Shelby1S,
    "Shelby2S" : Shelby2S,
    "Shelby3S" : Shelby3S,
    "Shelby4S" : Shelby4S,
    "Gentry1S" : Gentry1S,
    "Gentry2S" : Gentry2S,
    "Gentry3S" : Gentry3S



}

export default function ColoredInImage(props) {

    const ColorImage = components[props.component]

   
    return(
       
        <ColorImage id="svg-image" onFill={props.onFill} fillColors={props.fillColors} {...props} />   
        
    )
}